import styled from 'styled-components';
import { Box } from 'grommet';

export const LogInOutStyled = styled(Box)`  
  .form-sub-link {
    font-size: ${({ theme }) => theme.text.small.size };  
    line-height: ${({ theme }) => theme.text.small.height }; 
    margin-top: ${props => props.theme.global.edgeSize.small};
  }
`;